$(document).ready(() => {
    initSliderProduit();
    initSliderCrosssell();

    $(window).resize(() => {
        initSliderProduit();
        initSliderCrosssell();
    });
})

function initSliderProduit() {
    if (Foundation.MediaQuery.atLeast('large')) {
        if ($(".product-slider").hasClass("owl-carousel")) {
            $(".product-slider").removeClass("owl-carousel").trigger("destroy.owl.carousel");
            $(".product-slider").addClass("columns large-6");
        }
    }
    else {
        $(".product-slider").removeClass("columns large-6");
        $(".product-slider").addClass("owl-carousel").owlCarousel({
            loop: false,
            nav: false,
            margin: 8,
            stagePadding: 16,
            responsive: {
                0: {
                    items: 1
                },
                640: {
                    items: 2
                },
                1024: {
                    items: 3
                }
            },
        });
    }
}

function initSliderCrosssell() {
    $(".crosssell-slider").owlCarousel({
        loop: false,
        nav: false,
        margin: 10,
        responsive: {
            0: {
                items: 2
            },
            640: {
                items: 3
            },
            1024: {
                items: 4
            }
        },
    });
}
